const ReportSingleView = require('./ReportSingleView');
const StreamedEvents = require('../StreamedEvents');

class ReportEditView extends ReportSingleView {
  constructor(modal, btn) {
    super(modal, btn);

    this.currentWeek = $('.select-reportForWeek').val();
    this.missingTitlesInfo = $('.missing-titles-info');
  }

  init() {
    super.init();

    this.updateHeading(__('You are editing report for:'));
    this.fillEditData();
  }

  async onSubmitClick() {
    const postData = this.getReportDataFromElements();

    this.loading();

    await this.reportService.reportEdit(postData).done((data) => {
      this.onEditSuccess(data);
    })

    this.loading('reset');
  }

  showHideElements() {
    this.modal.find('#report-titles-body').show();
    this.modal.find('#report-no-titles-body').hide();

    this.modal.find('#report-all-info').hide();
    this.modal.find('#report-single-info').show();
  }

  fillEditData() {
    const data = this.getDataFromButton();

    this.streamedEventsEl.val(data.streamedEvents).trigger('change');
    this.recordingOptionEl.val(data.recordingOption).trigger('change');
  }

  getReportDataFromElements() {
    const data = this.buttonData;
    const graphicUsage = this.modal.find('select[name="graphic_source"] option:selected').html();
    const streamedEvents = this.streamedEventsEl.val();
    const recordingOption = this.recordingOptionEl.val();
    const license = this.licenseTypeSelect.val();
    const weeks = this.weeksSelect.val();

    const reportData = {
      idReprint:  license,
      idTitle: data.idTitle,
      idHymn: data.idHymn,
      idRegistration: data.idRegistration,
      idRegistrationSong: data.id,
      idSong: data.idSong,
      graphicUsage,
      weeks,
      streamedEvents,
      recordingOption
    };

    if (country !== 'AU' && country !== 'NZ') {
      delete reportData.graphicUsage;
    }

    return reportData;
  }

  onEditSuccess(data) {
    const graphicUsage = data.graphicUsage;
    const week = data.week;
    const streamedEvents = data.streamedEvents;
    const recordingOption = data.recordingOption;

    const $this = this;
    const btn = this.currentButton;
    this.hideModal();

    if (this.currentWeek && this.currentWeek !== week) {
      const lastItem = btn.parent().parent().parent();

      lastItem.slideToggle(300, function () {
        $(this).parent().remove();

        if (!$('.panel-report .row-title').length) {
          $this.missingTitlesInfo.fadeIn();
        }
      });
    } else {
      StreamedEvents.updateLabels(btn, streamedEvents, recordingOption);
    }
  }
}

module.exports = ReportEditView;
